import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/email.svg'
import _imports_1 from '../../assets/key.svg'
import _imports_2 from '../../assets/login.svg'


const _withScopeId = n => (_pushScopeId("data-v-7f6c2cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column",
  style: {"flex":"1"}
}
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Login", -1))
const _hoisted_6 = { action: "" }
const _hoisted_7 = { class: "modal-field input-group mb-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_9 = { class: "modal-field input-group mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Forgot password?")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Login ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Register", -1))
const _hoisted_17 = { class: "modal-field input-group mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select a Sprinklr environment", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-check mb-4" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "purchase-accept-terms"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" I accept the ")
const _hoisted_23 = ["href"]
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Please login or register to purchase this app",
    onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.purchase())),
    onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({name:'public-apps-details'}))),
    "min-width": "800px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  placeholder: "E-mail address",
                  "aria-label": "E-mail address",
                  "aria-describedby": "basic-addon1",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  placeholder: "Password",
                  "aria-label": "Password",
                  "aria-describedby": "basic-addon1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createVNode(_component_router_link, {
                to: {name: 'recover-password'},
                class: "d-block mb-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "submit",
                class: "btn-gradient btn-modal rounded-pill",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["stop","prevent"]))
              }, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control form-select mb-2",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEnv) = $event))
              }, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.environments, (env, envIdx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: envIdx,
                    value: env
                  }, _toDisplayString(env.name), 9, _hoisted_19))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedEnv]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                id: "purchase-accept-terms",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.acceptedTerms) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.acceptedTerms]
              ]),
              _createElementVNode("label", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("a", {
                  href: _ctx.termsUrl,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "terms and conditions", 8, _hoisted_23)
              ])
            ]),
            _createElementVNode("button", {
              class: "btn-gradient btn-connect-with-sprinklr rounded-pill",
              disabled: !_ctx.selectedEnv || !_ctx.acceptedTerms,
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openSprinklr(_ctx.selectedEnv)), ["stop","prevent"]))
            }, " Connect with Sprinklr ", 8, _hoisted_24)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}